import type { Branding } from './branding.ts';
import type { ConstantAssets } from './constant-assets.ts';
import type { CreatorSettings } from './creator-settings.ts';
import type { FeatureBadges } from './feature-badges.ts';
import type { FeatureFlags } from './feature-flags.ts';
import type { Integrations } from './integrations.ts';
import type { LegalLink } from './legal-links.ts';
import type { OnboardingConfig } from './onboarding-config.type.ts';
import type { TenantPages } from './pages.types.ts';
import type { PortalSettings } from './portal-settings.ts';

export enum ThemeScale {
	Sm = 'sm',
	Md = 'md',
	Lg = 'lg',
	Xl = 'xl'
}

export enum ThemeRadiusScale {
	Sm = 'sm',
	Md = 'md',
	Lg = 'lg',
	Xl = 'xl',
	Full = 'full'
}

export enum ThemeButtonVariant {
	Filled = 'filled',
	Outline = 'outline',
	Light = 'light',
	Subtle = 'subtle'
}

export type ToolbarButtonRadius = Exclude<
	ThemeRadiusScale,
	ThemeRadiusScale.Full
>;

export interface ToolbarButtonTheme {
	variant?: ThemeButtonVariant;
	color?: string;
	radius?: ToolbarButtonRadius;
}

export interface TenantMetadata {
	id: string;
	name: string;
	branding: Branding;
	agent_creator_url?: string | null;
	pages: TenantPages;
	integrations: Integrations;
	feature_flags: FeatureFlags;
	featureBadges: FeatureBadges;
	creator_settings: CreatorSettings;
	portal_settings: PortalSettings;
	legal_links: LegalLink[];
	onboarding: OnboardingConfig[];
	constant_assets?: ConstantAssets;
	theme?: {
		primary?: string[];
		secondary?: string[] | null;
		primaryColor?: string;
		primaryShade?: number;
		components?: {
			Button?: {
				defaultProps?: {
					radius?: number | string;
					color?: string;
					variant?: string;
					autoContrast?: boolean;
				};
			};
			Text?: {
				defaultProps?: {
					color?: string;
				};
			};
			ActionIcon?: {
				defaultProps?: {
					radius?: number | string;
					color?: string;
					variant?: string;
				};
			};
		};
		ui?: {
			logo?: {
				widthScale?: ThemeScale;
				heightScale?: ThemeScale;
			};
			text?: {
				subtitleColor?: string;
			};
			input?: {
				backgroundColor?: string;
			};
			toggle?: {
				backgroundColor?: string;
				radius?: ThemeRadiusScale;
			};
			toolbarButton?: ToolbarButtonTheme;
		};
	} | null;
}
